(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kadan-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.kadanHeroMenuButtonBound) {
    window.kadanHeroMenuButtonBound = true;

    const normaliseMenuLabel = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

    const findMenuSummary = (root, selector, targetLabel) => {
      if (!root) return null;

      return Array.from(root.querySelectorAll(selector)).find((summary) => {
        const labelElement = summary.querySelector('[data-text], .heading');
        return labelElement && normaliseMenuLabel(labelElement.textContent) === targetLabel;
      });
    };

    const openMenuSummary = (summary) => {
      if (!summary) return false;

      const details = summary.closest('details');
      if (!details || !details.hasAttribute('open')) {
        summary.click();
      }
      summary.focus();
      return true;
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-kadan-open-menu]');
      if (!button) return;

      const targetLabel = normaliseMenuLabel(button.dataset.kadanOpenMenu || 'Products');
      const header = document.querySelector('.header');
      const desktopSummary = findMenuSummary(
        header,
        '.header__menu details[is="details-mega"] > summary, .header__menu details[is="details-dropdown"] > summary',
        targetLabel
      );

      if (desktopSummary && desktopSummary.getClientRects().length > 0) {
        openMenuSummary(desktopSummary);
        return;
      }

      const drawerButton = Array.from(document.querySelectorAll('[aria-controls="MenuDrawer"]'))
        .find((control) => control.getClientRects().length > 0);

      if (!drawerButton) return;

      if (drawerButton.getAttribute('aria-expanded') !== 'true') {
        drawerButton.click();
      }

      window.setTimeout(() => {
        const drawerSummary = findMenuSummary(
          document.getElementById('MenuDrawer'),
          '.drawer__menu-group > details > summary',
          targetLabel
        );
        openMenuSummary(drawerSummary);
      }, 250);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadan-knx-commercial-applications"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kadan-commercial-applications')) {
    customElements.define('kadan-commercial-applications', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-application-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-application-panel]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectPanel(tab.dataset.applicationTab));
          tab.addEventListener('keydown', (event) => this.handleKeys(event, index));
        });
        this.querySelectorAll('[data-scene]').forEach((button) => button.addEventListener('click', () => this.selectScene(button)));
        this.querySelectorAll('[data-zone]').forEach((button) => button.addEventListener('click', () => this.toggleZone(button)));
      }
      selectPanel(id, focusTab = false) {
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.applicationTab === id;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          if (selected && focusTab) tab.focus();
        });
        this.panels.forEach((panel) => {
          const selected = panel.dataset.applicationPanel === id;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
      }
      selectScene(button) {
        const panel = button.closest('[data-application-panel]');
        if (!panel) return;
        this.resetZones(panel);
        this.applyScene(button, button.dataset.scene !== 'normal');
      }
      applyScene(button, showResult = false) {
        const panel = button.closest('[data-application-panel]');
        if (!panel) return;
        panel.dataset.mode = button.dataset.scene;
        panel.querySelectorAll('[data-scene]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        panel.querySelectorAll('[data-scene-image]').forEach((image) => {
          image.classList.toggle('is-engaged', image.dataset.sceneImage === button.dataset.scene);
        });
        const title = panel.querySelector('[data-live-title]');
        const lighting = panel.querySelector('[data-metric="lighting"]');
        const comfort = panel.querySelector('[data-metric="comfort"]');
        const occupancy = panel.querySelector('[data-metric="occupancy"]');
        if (title) title.textContent = button.dataset.title;
        if (lighting) lighting.textContent = button.dataset.lighting;
        if (comfort) comfort.textContent = button.dataset.comfort;
        if (occupancy) occupancy.textContent = button.dataset.occupancy;
        const result = panel.querySelector('[data-interaction-result]');
        if (result) {
          result.hidden = !showResult || !button.dataset.result;
          const resultTitle = result.querySelector('[data-interaction-title]');
          const resultCopy = result.querySelector('[data-interaction-copy]');
          if (resultTitle) resultTitle.textContent = `${button.textContent.trim()} — ${button.dataset.title}`;
          if (resultCopy) resultCopy.textContent = button.dataset.result || '';
        }
      }
      toggleZone(button) {
        const panel = button.closest('[data-application-panel]');
        if (!panel) return;
        if (panel.dataset.mode !== 'normal') {
          const normalScene = panel.querySelector('[data-scene="normal"]');
          if (normalScene) this.applyScene(normalScene, false);
        }
        const isActive = button.getAttribute('aria-pressed') === 'true';
        const nextActive = !isActive;
        if (!nextActive) this.resetZones(panel, button);
        const stateLabel = nextActive ? button.dataset.stateOn : button.dataset.stateOff;
        button.setAttribute('aria-pressed', nextActive ? 'true' : 'false');
        button.setAttribute('aria-label', `${button.dataset.label} — ${stateLabel}`);
        button.classList.toggle('is-standby', !nextActive);
        const effect = panel.querySelector(`[data-effect-layer="${button.dataset.zoneIndex}"]`);
        if (effect) effect.classList.toggle('is-engaged', !nextActive);
        const title = panel.querySelector('[data-live-title]');
        if (title) title.textContent = `${button.dataset.label} — ${stateLabel}`;
        const result = panel.querySelector('[data-interaction-result]');
        if (result) {
          result.hidden = nextActive;
          const resultTitle = result.querySelector('[data-interaction-title]');
          const resultCopy = result.querySelector('[data-interaction-copy]');
          if (resultTitle) resultTitle.textContent = `${button.dataset.label} — ${stateLabel}`;
          if (resultCopy) resultCopy.textContent = button.dataset.result;
        }
      }
      resetZones(panel, except = null) {
        panel.querySelectorAll('[data-zone]').forEach((zone) => {
          if (zone === except) return;
          zone.setAttribute('aria-pressed', 'true');
          zone.setAttribute('aria-label', `${zone.dataset.label} — ${zone.dataset.stateOn}`);
          zone.classList.remove('is-standby');
          const effect = panel.querySelector(`[data-effect-layer="${zone.dataset.zoneIndex}"]`);
          if (effect) effect.classList.remove('is-engaged');
        });
        const result = panel.querySelector('[data-interaction-result]');
        if (result) result.hidden = true;
      }
      handleKeys(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.selectPanel(this.tabs[next].dataset.applicationTab, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadan-knx-commercial-connections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kadan-commercial-connections')) {
    customElements.define('kadan-commercial-connections', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-signal]').forEach((button) => button.addEventListener('click', () => this.activate(button.dataset.signal)));
        this.activate('switch');
      }
      activate(signal) {
        this.querySelectorAll('[data-signal]').forEach((button) => {
          const selected = button.dataset.signal === signal;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        this.querySelectorAll('[data-route]').forEach((item) => {
          const selected = item.dataset.route.split(' ').includes(signal);
          item.classList.toggle('is-selected', selected);
          item.classList.toggle('is-muted', !selected);
          item.removeAttribute('data-active-step');
          const step = item.dataset[`${signal}Step`];
          if (selected && step) item.setAttribute('data-active-step', step);
        });
        this.querySelector('[data-result-title]').textContent = this.dataset[`${signal}Title`];
        this.querySelector('[data-result-copy]').textContent = this.dataset[`${signal}Copy`];
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadan-knx-commercial-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kadan-commercial-overview')) {
    customElements.define('kadan-commercial-overview', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-building-tab]'));
        this.hotspots = Array.from(this.querySelectorAll('[data-building-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-building-panel]'));

        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectBuilding(tab.dataset.buildingTab)));
        this.hotspots.forEach((hotspot) => hotspot.addEventListener('click', () => this.selectBuilding(hotspot.dataset.buildingTrigger)));
        this.tabs.forEach((tab, index) => tab.addEventListener('keydown', (event) => this.handleKeys(event, index)));

        const configElement = this.querySelector('[data-commercial-overview-config]');
        if (configElement) {
          try {
            const config = JSON.parse(configElement.textContent);
            if (config.firstBuilding) this.selectBuilding(config.firstBuilding, false);
          } catch (error) {
            this.selectBuilding(this.tabs[0] ? this.tabs[0].dataset.buildingTab : '', false);
          }
        }
      }

      selectBuilding(id, focusTab = false) {
        if (!id) return;
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.buildingTab === id;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          if (selected && focusTab) tab.focus();
        });
        this.hotspots.forEach((hotspot) => {
          const selected = hotspot.dataset.buildingTrigger === id;
          hotspot.classList.toggle('is-active', selected);
          hotspot.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          const selected = panel.dataset.buildingPanel === id;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
      }

      handleKeys(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.selectBuilding(this.tabs[nextIndex].dataset.buildingTab, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadan-knx-commercial-value"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kadan-commercial-value')) {
    customElements.define('kadan-commercial-value', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-role-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-role-panel]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab.dataset.roleTab));
          tab.addEventListener('keydown', (event) => this.handleKeys(event, index));
        });
      }
      select(id, focus = false) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.roleTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focus) tab.focus();
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.rolePanel !== id; });
      }
      handleKeys(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.select(this.tabs[next].dataset.roleTab, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadan-knx-ecosystem"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kadan-knx-ecosystem')) {
    customElements.define('kadan-knx-ecosystem', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-eco-tab]')];
        this.panels = [...this.querySelectorAll('[data-eco-panel]')];
        this.nodes = [...this.querySelectorAll('[data-eco-node]')];
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab)));
      }

      activate(selected) {
        const panelId = selected.getAttribute('aria-controls');
        const activePanel = this.querySelector(`#${CSS.escape(panelId)}`);
        const blockId = activePanel && activePanel.dataset.ecoPanel;
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          const active = panel === activePanel;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        this.nodes.forEach((node) => node.classList.toggle('is-active', node.dataset.ecoNode === blockId));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadan-knx-home-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kadan-knx-home-experience')) {
    class KadanKnxHomeExperience extends HTMLElement {
      connectedCallback() {
        this.sceneTriggers = Array.from(this.querySelectorAll('[data-scene-trigger]'));
        this.scenePanels = Array.from(this.querySelectorAll('[data-scene-panel]'));
        this.sceneDetails = Array.from(this.querySelectorAll('[data-scene-detail]'));
        this.hotspotTriggers = Array.from(this.querySelectorAll('[data-hotspot-trigger]'));
        this.hotspotPanels = Array.from(this.querySelectorAll('[data-hotspot-panel]'));
        this.systemTriggers = Array.from(this.querySelectorAll('[data-system-trigger]'));
        this.systemPanels = Array.from(this.querySelectorAll('[data-system-panel]'));
        this.systemInputs = Array.from(this.querySelectorAll('[data-system-input]'));
        this.state = {};

        this.sceneTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            this.activateScene(trigger.dataset.sceneTrigger);
            this.closePanels();
          });
        });

        this.hotspotTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const targetScene = trigger.dataset.targetScene;
            if (targetScene && targetScene !== '0') this.activateScene(targetScene);
            this.openPanel(trigger.dataset.hotspotTrigger);
          });
        });

        this.systemTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.openSystemPanel(trigger.dataset.systemTrigger));
        });

        this.systemInputs.forEach((input) => {
          input.addEventListener('input', () => this.updateSystem(input.dataset.systemInput, Number(input.value), input));
        });

        this.querySelectorAll('[data-security-option]').forEach((button) => {
          button.addEventListener('click', () => this.updateSecurity(button.dataset.securityOption));
        });

        this.querySelectorAll('[data-panel-close]').forEach((button) => {
          button.addEventListener('click', () => this.closePanels());
        });

        this.querySelectorAll('[data-system-close]').forEach((button) => {
          button.addEventListener('click', () => this.closePanels());
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.closePanels();
        });

        const initialDetail = this.sceneDetails.find((detail) => detail.classList.contains('is-active'));
        if (initialDetail) this.applySceneState(initialDetail);
      }

      activateScene(index) {
        this.scenePanels.forEach((panel) => {
          const active = panel.dataset.scenePanel === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });

        this.sceneDetails.forEach((detail) => {
          const active = detail.dataset.sceneDetail === index;
          detail.classList.toggle('is-active', active);
          detail.hidden = !active;
        });

        this.sceneTriggers.forEach((trigger) => {
          const active = trigger.dataset.sceneTrigger === index;
          trigger.classList.toggle('is-active', active);
          trigger.setAttribute('aria-pressed', String(active));
        });

        const activeDetail = this.sceneDetails.find((detail) => detail.dataset.sceneDetail === index);
        if (activeDetail) this.applySceneState(activeDetail);
      }

      applySceneState(detail) {
        const lighting = Number(detail.dataset.lightLevel || 70);
        const blinds = Number(detail.dataset.blindsLevel || 0);
        const climate = Number(detail.dataset.climateTemperature || 22);
        const security = detail.dataset.securityStatus || '';

        this.state = { lighting, blinds, climate, security };
        this.style.setProperty('--knx-light-level', lighting);
        this.style.setProperty('--knx-light-brightness', 0.55 + lighting * 0.0065);
        this.style.setProperty('--knx-warm-glow', lighting / 100);
        this.style.setProperty('--knx-blinds-level', blinds);
        this.style.setProperty('--knx-blinds-opacity', blinds / 100);
        this.style.setProperty('--knx-climate-shift', climate - 22);
        this.setSystemDisplay('lighting', detail.dataset.lightingStatus || `${lighting}%`);
        this.setSystemDisplay('blinds', detail.dataset.blindsStatus || this.blindsLabel(blinds));
        this.setSystemDisplay('climate', detail.dataset.climateStatus || `${climate}°C`);
        this.setSystemDisplay('security', security);
        this.syncInputs();
      }

      updateSystem(system, value, input) {
        this.state[system] = value;
        if (system === 'lighting') {
          this.style.setProperty('--knx-light-level', value);
          this.style.setProperty('--knx-light-brightness', 0.55 + value * 0.0065);
          this.style.setProperty('--knx-warm-glow', value / 100);
          this.setSystemDisplay(system, `${value}%`);
        }
        if (system === 'blinds') {
          this.style.setProperty('--knx-blinds-level', value);
          this.style.setProperty('--knx-blinds-opacity', value / 100);
          this.setSystemDisplay(system, this.blindsLabel(value, input));
        }
        if (system === 'climate') {
          this.style.setProperty('--knx-climate-shift', value - 22);
          this.setSystemDisplay(system, `${value}°C`);
        }
      }

      updateSecurity(value) {
        this.state.security = value;
        this.setSystemDisplay('security', value);
        this.querySelectorAll('[data-security-option]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.securityOption === value);
        });
      }

      blindsLabel(value, input = this.querySelector('[data-system-input="blinds"]')) {
        if (!input) return `${value}%`;
        if (value <= 0) return input.dataset.optionOne || 'Open';
        if (value >= 100) return input.dataset.optionThree || 'Privacy';
        return input.dataset.optionTwo || 'Half';
      }

      setSystemDisplay(system, label) {
        this.querySelectorAll(`[data-system-value="${system}"], [data-panel-value="${system}"]`).forEach((element) => {
          element.textContent = label;
        });
        this.querySelectorAll(`[data-system-trigger="${system}"]`).forEach((trigger) => {
          trigger.setAttribute('aria-label', `${trigger.dataset.systemName}: ${label}`);
        });
        const activeState = this.querySelector(`.kadan-knx-home__scene-detail.is-active [data-state-value="${system}"]`);
        if (activeState) activeState.textContent = label;
      }

      syncInputs() {
        this.systemInputs.forEach((input) => {
          const value = this.state[input.dataset.systemInput];
          if (typeof value === 'number') input.value = value;
        });
        this.querySelectorAll('[data-security-option]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.securityOption === this.state.security);
        });
      }

      openSystemPanel(system) {
        this.hotspotPanels.forEach((panel) => panel.hidden = true);
        this.systemPanels.forEach((panel) => {
          panel.hidden = panel.dataset.systemPanel !== system;
        });
        this.systemTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', String(trigger.dataset.systemTrigger === system));
        });
        this.hotspotTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      }

      openPanel(id) {
        this.systemPanels.forEach((panel) => panel.hidden = true);
        this.systemTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.hotspotPanels.forEach((panel) => {
          panel.hidden = panel.dataset.hotspotPanel !== id;
        });

        this.hotspotTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', String(trigger.dataset.hotspotTrigger === id));
        });
      }

      closePanels() {
        this.hotspotPanels.forEach((panel) => {
          panel.hidden = true;
        });
        this.systemPanels.forEach((panel) => {
          panel.hidden = true;
        });
        this.hotspotTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.systemTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      }
    }

    customElements.define('kadan-knx-home-experience', KadanKnxHomeExperience);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadan-knx-why"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kadan-knx-comparison')) {
    customElements.define('kadan-knx-comparison', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-compare-tab]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.activate(tab)));
      }

      activate(selected) {
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          const active = panel.id === selected.getAttribute('aria-controls');
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
